import { ColumnDef } from "@tanstack/react-table";
import type { ClientsheetPublic } from "@/client";
import { Checkbox } from "@/components/ui/checkbox";
import { getFileNameFromFilePath } from "@/lib/utils";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DownloadClientsheetButton } from "./DownloadClientsheetButton";

export const columns: ColumnDef<ClientsheetPublic>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
        className="translate-y-[2px]"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
        className="translate-y-[2px]"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "date",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="Date" />
      </div>
    ),
    cell: ({ row }) => {
      return <div> {row.getValue("date")}</div>;
    },
  },
  {
    accessorKey: "id",
    header: ({ column }) => <DataTableColumnHeader column={column} title="ID" />,
    cell: ({ row }) => <div>{getFileNameFromFilePath(row.getValue("id"))}</div>,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "Download",
    enableSorting: false,
    header: ({ column }) => {
      return (
        <div className="flex items-center justify-center">
          <DataTableColumnHeader column={column} title="Download" />
        </div>
      );
    },
    cell: ({ row }) => {
      const date = row.getValue("date");

      if (typeof date !== "string") {
        return null;
      }

      return <DownloadClientsheetButton date={date} />;
    },
    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id));
    },
  },
];
